import { useEffect, useState } from "react";

/**
 * Debounce a value by `delayMs`. Returns the previous value until the input has
 * been stable for `delayMs`, then updates to the latest value.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => {
      setDebounced(value);
    }, delayMs);
    return () => {
      clearTimeout(id);
    };
  }, [value, delayMs]);

  return debounced;
}
